import { makeStyles } from '@material-ui/core';

export const visualizarServicoStyles = makeStyles({
  dialogPaper: {
    maxWidth: 700,
  },
  cellServicos: {
    padding: '6px 0px 6px 16px',
  },
  icon: {
    padding: '5px',
    color: '#43a047',
  },
  iconText: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
});
